import { ButtonMain } from '@/modules/common/components/button';
import styles from './index.module.sass';
import { getBestMarketPricesFx, getBestMarketPricesTabFx } from '@/modules/mixing/store/analytical-mixing.store';
import { useStore } from 'effector-react';
import { $moistureChangesDensity } from '@/modules/mixing/store/recipes.store';
import { fetchWarehousesForMixingDataFx } from '@/widgets/recipe/model';

export const SellOption = ({
  title,
  tags,
  offerData,
  action,
  viewOnly,
  totalPriceColor,
  withoutLogisitic,
  isWarehouseTypeSleeve,
  onSuccess,
}: ISellOption) => {
  const moistureChangesDensity = useStore($moistureChangesDensity);
  
  return (
    <div className={styles.root}>
      <span className={styles.title}>{title}</span>
      <div className={styles.tags}>
        {tags.map((item, i) => (
          <span
            key={i}
            className={styles.tagItem}
            style={{
              backgroundColor: item.color,
              opacity: item.display === false ? 0 : 1,
            }}
          >
            {item.text}
          </span>
        ))}
      </div>
      <ul className={styles.offerData}>
        <li>
          <span className={styles.label}>{`конечный вес ${isWarehouseTypeSleeve? 'рукава' : 'объёма'}`}</span>
          <span className={styles.value}>
            {offerData?.weight?.toLocaleString('ru') ?? 0}
            <span className={styles.postfix}>т</span>
          </span>
        </li>

        { !withoutLogisitic && <>
        <li>
          <span className={styles.label}>{`стоимость ${isWarehouseTypeSleeve? 'рукава' : 'объёма'}`}</span>
          <span className={styles.value}>
            {offerData?.grainPrice?.toLocaleString('ru') ?? 0}
            <span className={styles.postfix}>₽</span>
          </span>
        </li>
        <li>
          <span className={styles.label}>стоимость логистики</span>
          <span className={styles.value}>
            {offerData?.freightPrice?.toLocaleString('ru') ?? 0}
            <span className={styles.postfix}>₽</span>
          </span>
        </li>
        </>}
        <li>
          <span className={styles.label}>{`конечная стоимость ${isWarehouseTypeSleeve? 'рукава' : 'объёма'}`}</span>
          <span
            className={styles.value}
            style={{ color: totalPriceColor || 'inherit' }}
          >
            {offerData?.totalPrice?.toLocaleString('ru') ?? 0}
            <span className={styles.postfix}>₽</span>
          </span>
        </li>
      </ul>
      {!viewOnly && (
        <ButtonMain
          label="выбрать"
          className={styles.button}
          active={!action.disabled}
          onClick={async () => {
            await action.onClick();
            await fetchWarehousesForMixingDataFx({ tons: 0 } as any);
            await getBestMarketPricesTabFx({ trade: true, moistureChangesDensity });
            onSuccess && await onSuccess();
          }}
        />
      )}
    </div>
  );
};

export interface ISellOption {
  viewOnly?: boolean;
  title: string;
  totalPriceColor?: string;
  tags: { text: string; color: string; display?: boolean }[];
  offerData: {
    weight: number | string;
    grainPrice: number | string;
    freightPrice: number | string;
    totalPrice: number | string;
  };
  isWarehouseTypeSleeve?: boolean;
  withoutLogisitic?: boolean; 
  action: {
    onClick: () => Promise<void>;
    disabled: boolean;
  };
  onSuccess?: () => Promise<void>;
}
